import { ReactNode } from 'react';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Badge } from '@/components/ui/daisy';

type PendencyRowProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  count: number;
};

// TODO: navigate to the pendency target once the destination screens exist (CT-04)
export default function PendencyRow({
  icon,
  title,
  description,
  count,
}: PendencyRowProps) {
  return (
    <li
      data-testid="pendencyRow"
      className="flex items-center gap-3 rounded-2xl bg-base-300 md:bg-base-200 p-4 md:flex-1 md:max-h-[calc(50%-0.375rem)]"
    >
      <span className="flex size-7 shrink-0 items-center justify-center rounded-md bg-base-300 text-base-content">
        {icon}
      </span>
      <span className="flex min-w-0 grow flex-col gap-0.5">
        <span className="truncate text-xs font-semibold text-base-content">
          {title}
        </span>
        <ConditionalRenderer condition={!!description}>
          <span className="truncate text-[0.687rem] text-base-content">
            {description}
          </span>
        </ConditionalRenderer>
      </span>
      <Badge
        size="md"
        variant="soft"
        color="primary"
        className="text-xs font-semibold rounded-full px-2.5 py-1 bg-primary/10"
      >
        {count}
      </Badge>
    </li>
  );
}
